var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-row',[_c('v-col',[_c('ayuda-video-player',{attrs:{"video":_vm.selectedVideo}})],1),_c('v-col',{attrs:{"cols":"12","md":"4","sm":"6"}},[_c('ayuda-menu',{attrs:{"selectedCategory":_vm.selectedCategory}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }